import i from "./generateUtilityClass.mjs";
import r from "./generateUtilityClasses.mjs";
function a(t) {
  return i("MuiTypography", t);
}
r("MuiTypography", ["root", "h1", "h2", "h3", "h4", "h5", "h6", "subtitle1", "subtitle2", "body1", "body2", "inherit", "button", "caption", "overline", "alignLeft", "alignRight", "alignCenter", "alignJustify", "noWrap", "gutterBottom", "paragraph"]);
export {
  a as getTypographyUtilityClass
};
//# sourceMappingURL=typographyClasses.mjs.map
